/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";
import { Modal } from "components/common/Modal";
import Footer from "components/desktop/Footer";
import { Header } from "components/desktop/Header";
import Menu from "components/desktop/Menu";
import MarqueeCustom from "pages/desktop/HomePage/Marquee";
import { Outlet } from "react-router-dom";
import { media } from "styles/breakpoints";

export const DefaultLayout = () => {
  return (
    <div
      css={css`
        min-width: 1480px;
        ${media.xxl} {
          min-width: unset;
          width: 100%;
        }
      `}
    >
      <Header />
      <Menu />
      <MarqueeCustom />
      <main css={css``}>
        <Outlet />
      </main>
      <Footer />
      <Modal />
    </div>
  );
};
